const consent = {
  'consent.title': '使用前請閱讀並同意',
  'consent.subtitle': '首次使用需確認以下重要聲明，保障您的權益',
  'consent.entertainment.title': '娛樂性質聲明',
  'consent.entertainment.content': '本應用功能及內容信息僅供用戶娛樂使用，不等于專業測評，不代表價值評判，僅供娛樂參考，不可作為任何現實指導意義。',
  'consent.entertainment.strong1': '僅供用戶娛樂使用',
  'consent.entertainment.strong2': '不可作為任何現實指導意義',
  'consent.privacy.title': '本地隱私保護',
  'consent.privacy.content': '您的檔案信息和聊天記錄不上傳雲端，完全本地保護。所有命理分析基於實際情況嚴謹遵循命理之道，不恐嚇、不製造焦慮。遇到不利運勢，理性分析，提供優化參考。',
  'consent.privacy.strong': '檔案信息和聊天記錄不上傳雲端，完全本地保護',
  'consent.philosophy.title': '我們的命理哲學',
  'consent.philosophy.content': '根據用戶信息嚴謹遵循命理分析之道，不恐嚇、不製造焦慮。如若遇到不利運勢，理性客觀闡述，提供優化參考。運勢流年是順勢而為的參考，而不是不可改變的定論；命理是認識自我的工具，不是束縛命運的枷鎖。我們不只告知「是什麼」，更清晰指引「怎麼辦」，讓命理真正服務於生活。',
  'consent.viewTerms': '查看服務條款',
  'consent.viewPrivacy': '查看隱私政策',
  'consent.checkbox.part1': '我已閱讀並同意',
  'consent.terms': '服務使用條款',
  'consent.checkbox.and': '及',
  'consent.privacyPolicy': '隱私政策',
  'consent.checkbox.part2': '，了解本應用為娛樂性質，所有命理分析不可作為任何現實決策依據，且我的個人數據受到本地隱私保護。',
  'consent.checkbox.postStrong': '不可作為任何現實決策依據',
  'consent.agreeButton': '同意並繼續使用',
  'consent.pleaseAgree': '請先勾選同意後繼續',
};

export default consent;
